/* eslint-disable react-hooks/exhaustive-deps */
import { FC, useCallback, useEffect, useMemo, useState } from "react";
import { TCarrinhoAvulso } from "../types";
import { Box, Chip, IconButton } from "@mui/material";
import { Formater, LocalStorage, TypeRecords } from "src/framework/commons";
import InputQuantidade from "src/framework/components/forms/inputs/InputQuantidade";
import { Delete, WarningAmberOutlined } from "@mui/icons-material";
import Grid from '@mui/material/Grid';

import './styles.scss';
import { CarrinhoStoreClass } from "../store";
import { avulsos$, estadoId$, resolveUploadUrl } from "src/store/global.store";
import { useObservable } from "src/framework/store/storeUtil";
import { CABO_ID, VALOR_MULTIPLO_CABO } from "src/pages/Home/constants";
import { ADMIN_MAX_VALUE, MENSAGEM_QUANTIDADE_CABOS_INVALIDA } from "src/constants";
import { PermissionUtil } from "src/framework/commons/PermissionUtil";
import { permissoes$ } from "src/framework/store";

interface IItem {
    item: TCarrinhoAvulso;
    index: number;
    onRemove: (index: number) => void;
    onChange: (index: number, quantidade: number) => void;
}

const ItemAvulso:FC<IItem> = ({ item, index, onRemove, onChange }) => {
    const estadoId = useObservable(estadoId$) || "";
    const avulsos = useObservable(avulsos$) || [];
    const uploadUrl = resolveUploadUrl(LocalStorage.get("solar.uploads", true) || null) || ""
    const [quantidadeMax, setQuantidadeMax] = useState<number>(1);
    const [quantidadeMin, setQuantidadeMin] = useState<number>(1);
    const [quantidade, setQuantidade] = useState<number>(item.quantidade);

    const imgUrl = useCallback(() => {
        return `//${uploadUrl}${item?.componente?.imagem}` || "";
    }, [item.componente?.imagem, uploadUrl]);

    const valorPorQuantidade = () => { 
       return CarrinhoStoreClass.valorAvulso(item, estadoId) * quantidade;
    }
    
    const isAdmin = useMemo(() => {
        return PermissionUtil.isAdministrador(permissoes$.value);
    }, []);

    useEffect(()=>{
        if (item?.componente) {        
            setQuantidadeMax(item?.componente?.quantidade_maxima_venda_avulso || (item?.componente?.categoria_componentes_id === CABO_ID ? VALOR_MULTIPLO_CABO : quantidadeMax));
            setQuantidadeMin(item?.componente?.categoria_componentes_id === CABO_ID ? VALOR_MULTIPLO_CABO : quantidadeMin);
        }
    },[]);

    const checkError = useCallback((categoriaId: number, qtd: number): boolean => {
        if (categoriaId !== CABO_ID) {
            return false;
        }
        if (qtd === 0) {
            return false;
        }
        if (qtd % 25 === 0) {
            return false;
        }
        return true
    }, []);

    const indisponivel = useMemo((): boolean => {
        const itensIds = avulsos?.data?.map((i: any) => i?.id) || [];
        return !itensIds?.includes(item?.componente?.id);
    }, [item?.componente, avulsos?.data, estadoId]);

    return (
            <Box className="Item">
                <Grid className="box-container">
                    <Grid className="box-imagem" size="grow">
                        <img className={`imagem ${indisponivel ? 'imagem-indisponivel' : ''}`} src={imgUrl()} alt="" />
                    </Grid>
                    <Grid className="box-detalhes" size="grow">
                        <Box className={`produto-nome ${indisponivel ? 'item-indisponivel' : ''}`}><strong style={{wordWrap: "break-word"}}>{item?.componente?.nome || ""}</strong></Box>
                        {indisponivel ? (
                            <Chip
                                label="INDISPONÍVEL"
                                color="error"
                                size="small"
                                variant="outlined"
                                icon={<WarningAmberOutlined />}
                                sx={{
                                    width: '130px',
                                    fontSize: '11px',
                                    fontWeight: 600
                                }}
                            />
                        ) : (
                            <Box className="valor-total">{Formater.toString(valorPorQuantidade(), TypeRecords.CURRENCY)} <span className="quantidade_valor">({quantidade}x {Formater.toString(CarrinhoStoreClass.valorAvulso(item, estadoId), TypeRecords.CURRENCY)})</span></Box>
                        )}
                    </Grid>
                    <Grid className="box-quantidade" size="grow" flexDirection="column">
                        <InputQuantidade 
                            avulso
                            value={quantidade}
                            hasError={checkError(item?.componente?.categoria_componentes_id || 0, quantidade)}
                            multiple={item?.componente?.categoria_componentes_id === CABO_ID ? VALOR_MULTIPLO_CABO : 1}
                            disableMenos={quantidade <= 1}
                            disabled={indisponivel}
                            maxValue={!isAdmin ? quantidadeMax : ADMIN_MAX_VALUE}
                            minValue={quantidadeMin}
                            onChange={(e: any) => {
                                onChange(index, (e || 1));
                                setQuantidade(e || 1);
                            }}
                        />
                        <Grid size={12}>
                            {item?.componente?.categoria_componentes_id === CABO_ID && checkError(item?.componente?.categoria_componentes_id, quantidade) && (
                                <span style={{ color: "#b91322" }}>{MENSAGEM_QUANTIDADE_CABOS_INVALIDA}</span>
                            )}
                        </Grid>
                    </Grid>
                    <Grid className="box-remover" size="grow">
                        <IconButton onClick={() => onRemove(index)} size="large"><Delete color="error"/></IconButton>
                    </Grid>
                </Grid>
            </Box>
    );
}

export { ItemAvulso }